import type { AddLocationLocationType } from "@/Shared/Types/locationTypes";
import { CountryCode } from "@freightsimple/generated-dashboard-openapi-client/models/CountryCode";

export function isDomesticCanada(
  pickup: AddLocationLocationType,
  delivery: AddLocationLocationType,
) {
  return (
    pickup.address.countryCode === CountryCode.Canada &&
    delivery.address.countryCode === CountryCode.Canada
  );
}
